import styles from "./SpeechBubble.module.scss";
import { STATUS_CONTENT, STATUS_KEYS, type StatusKey } from "./data";
import clsx from "clsx";
import { SpeechBubbleArrow } from "../../assets/icons";

interface SpeechBubbleProps {
  status: StatusKey;
}

export const SpeechBubble = ({ status }: SpeechBubbleProps) => {
  const { paragraphs } = STATUS_CONTENT[status];

  const classMap: Record<StatusKey, string> = {
    [STATUS_KEYS.SERVER_OK]: styles.speechOk,
    [STATUS_KEYS.SERVER_ERROR]: styles.speechError,
    [STATUS_KEYS.PROJECT_SUCCESS]: styles.speechProjectSuccess,
    [STATUS_KEYS.PROJECT_ERROR]: styles.speechProjectError,
  };

  return (
    <div className={clsx(styles.speechBubble, classMap[status])}>
      {paragraphs.map((p, i) => (
        <p key={i} className={styles.paragraph}>
          {p}
        </p>
      ))}
      <SpeechBubbleArrow className={styles.arrow} />
    </div>
  );
};